
export const rw = {
  // Common
  "Login": "Injira",
  "Logout": "Sohoka",
  "Register": "Iyandikishe",
  "Search": "Shakisha",
  "Cart": "Igare",
  "Profile": "Umwirondoro",
  "Home": "Ahabanza",
  "Products": "Ibicuruzwa",
  "Categories": "Ibyiciro",
  "Orders": "Amasezerano",
  "Settings": "Igenamiterere",
  "Continue": "Komeza",
  "Back": "Gusubira inyuma",
  "Save": "Bika",
  "Cancel": "Hagarika",
  "Submit": "Ohereza",
  "Delete": "Gusiba",
  "Edit": "Hindura",
  "Add": "Ongeramo",
  "Remove": "Kuramo",
  "Next": "Ibikurikira",
  "Previous": "Ibanjirije",
  "Loading": "Biratunganywa...",
  "Error": "Ikibazo",
  "Success": "Byagenze neza",
  "Warning": "Iburira",
  "Info": "Amakuru",
  "Close": "Funga",
  "Confirm": "Emeza",
  "Yes": "Yego",
  "No": "Oya",
  "Or": "Cyangwa",
  "All": "Byose",
  "More": "Ibindi",
  "Less": "Bike",
  "Show more": "Erekana ibindi",
  "Show less": "Erekana bike",
  "Read more": "Soma ibindi",
  "Read less": "Soma bike",
  "See more": "Reba ibindi",
  "See less": "Reba bike",
  "View more": "Reba ibindi",
  "View less": "Reba bike",
  "Load more": "Bona ibindi",
  "Load less": "Bona bike",
  "Processing": "Biratunganywa...",
  "Sending": "Kohereza...",
  "Password": "Ijambo ryibanga",
  "Confirm Password": "Emeza ijambo ryibanga",
  "Email": "Imeyili",
  "Username": "Izina ry'ukoresha",
  "First Name": "Izina",
  "Last Name": "Izina ry'umuryango",
  "Full Name": "Amazina yose",
  "Address": "Aderesi",
  "City": "Umujyi",
  "Country": "Igihugu",
  "State": "Intara",
  "Zip Code": "Kode y'iposita",
  "Phone": "Telefoni",
  "Date": "Itariki",
  "Time": "Igihe",
  "Price": "Igiciro",
  "Quantity": "Ingano",
  "Total": "Igiteranyo",
  "Subtotal": "Igiteranyo cy'ibiciro",
  "Tax": "Umusoro",
  "Shipping": "Gutanga",
  "Payment": "Kwishyura",
  "Order": "Gahunda",
  "Order Number": "Nomero ya gahunda",
  "Order Date": "Itariki ya gahunda",
  "Order Status": "Imimerere ya gahunda",
  "Order Total": "Igiteranyo cya gahunda",
  "Order Details": "Ibisobanuro bya gahunda",
  "Order Items": "Ibintu bya gahunda",
  "Order History": "Amateka ya gahunda",
  "New Order": "Gahunda nshya",
  "Cancel Order": "Hagarika gahunda",
  "Checkout": "Kwishyura",
  "Shipping Address": "Aderesi yo gutanga",
  "Billing Address": "Aderesi yo kwishyura",
  "Payment Method": "Uburyo bwo kwishyura",
  "Credit Card": "Ikarita yo kwishyura",
  "PayPal": "PayPal",
  "Cash": "Amakashi",
  "Mobile Money": "Amafaranga ya telefoni",
  "Bank Transfer": "Ihererekanya ry'amabanki",
  "Product": "Igicuruzwa",
  "Product Name": "Izina ry'igicuruzwa",
  "Product Description": "Ibisobanuro by'igicuruzwa",
  "Product Price": "Igiciro cy'igicuruzwa",
  "Product Image": "Ishusho y'igicuruzwa",
  "Product Category": "Icyiciro cy'igicuruzwa",
  "Product Brand": "Izina ry'igicuruzwa",
  "Product Model": "Modeli y'igicuruzwa",
  "Product Color": "Ibara ry'igicuruzwa",
  "Product Size": "Ingano y'igicuruzwa",
  "Product Weight": "Uburemere bw'igicuruzwa",
  "Product Availability": "Kuboneka kw'igicuruzwa",
  "In Stock": "Birahari",
  "Out of Stock": "Ntibiboneka",
  "Add to Cart": "Shyira mu igare",
  "Remove from Cart": "Kura mu igare",
  "Wishlist": "Urutonde rw'ibyo wishaka",
  "Add to Wishlist": "Shyira ku rutonde rw'ibyo wishaka",
  "Remove from Wishlist": "Kura ku rutonde rw'ibyo wishaka",
  "Related Products": "Ibicuruzwa bijyanye",
  "Popular Products": "Ibicuruzwa bikunzwe",
  "Featured Products": "Ibicuruzwa by'ingenzi",
  "New Products": "Ibicuruzwa bishya",
  "Best Sellers": "Ibyiza cyane",
  "Special Offers": "Ibiciro by'umwihariko",
  "Deals": "Amasezerano",
  "Sale": "Igurisha",
  "Limited Time Offer": "Igihe gito",
  "Free Shipping": "Gutanga ku buntu",
  "Express Shipping": "Gutanga byihuse",
  "Standard Shipping": "Gutanga busanzwe",
  "Delivery": "Gutanga",
  "Delivery Time": "Igihe cyo gutanga",
  "Delivery Address": "Aderesi yo gutanga",
  "Delivery Method": "Uburyo bwo gutanga",
  "Pickup": "Gufata",
  "Pickup Location": "Aho gufatira",
  "Pickup Time": "Igihe cyo gufata",
  "Return": "Gusubiza",
  "Return Policy": "Amategeko yo gusubiza",
  "Refund": "Kugaruza amafaranga",
  "Refund Policy": "Amategeko yo kugaruza amafaranga",
  "Exchange": "Guhindura",
  "Exchange Policy": "Amategeko yo guhindura",
  "Warranty": "Garanti",
  "Warranty Period": "Igihe cya garanti",
  "Terms and Conditions": "Amabwiriza n'amategeko",
  "Privacy Policy": "Amategeko y'ibanga",
  "FAQ": "Ibibazo bikunze kubazwa",
  "Help": "Ubufasha",
  "Support": "Inkunga",
  "Contact": "Twandikire",
  "Contact Us": "Twandikire",
  "About": "Ibyerekeye",
  "About Us": "Ibyerekeye",
  "Blog": "Blog",
  "News": "Amakuru",
  "Events": "Ibikorwa",
  "Gallery": "Amafoto",
  "Reviews": "Ibitekerezo",
  "Testimonials": "Ubuhamya",
  "Rating": "Guha amanota",
  "Comments": "Ibitekerezo",
  "Share": "Gusangiza",
  "Follow": "Gukurikira",
  "Like": "Gukunda",
  "Social Media": "Imbuga nkoranyambaga",
  "Newsletter": "Amakuru shingiro",
  "Subscribe": "Kwiyandikisha",
  "Unsubscribe": "Kwiyandukuza",
  "Welcome": "Murakaza neza",
  "Hello": "Muraho",
  "Goodbye": "Murabeho",
  "Thank You": "Murakoze",
  "Sorry": "Mutwihanganire",
  "Congratulations": "Twishimiye",
  "Confirm your email": "Emeza imeyili yawe",
  "Forgot your password?": "Wibagiwe ijambo ryibanga?",
  "Reset Password": "Guhindura ijambo ryibanga",
  "Create an account": "Kora konti",
  "Already have an account?": "Usanzwe ufite konti?",
  "Don't have an account?": "Nta konti ufite?",
  "Sign In": "Injira",
  "Sign Up": "Iyandikishe",
  "Sign Out": "Sohoka",
  "Remember Me": "Unyibuke",
  "Stay Signed In": "Guma winjiye",
  "Guest": "Umushyitsi",
  "Profile Picture": "Ifoto y'umwirondoro",
  "Upload": "Kohereza",
  "Download": "Kuramo",
  "File": "Dosiye",
  "Attachment": "Umugereka",
  "Image": "Ifoto",
  "Video": "Videwo",
  "Audio": "Amajwi",
  "Document": "Inyandiko",
  "Upload Failed": "Kohereza byanze",
  "Download Failed": "Kuramo byanze",
  "File Not Found": "Dosiye ntiboneka",
  "Invalid File": "Dosiye itemewe",
  "File Too Large": "Dosiye nini cyane",
  "Invalid File Type": "Ubwoko bwa dosiye butemewe",
  "Please Try Again": "Gerageza nanone",
  "System Error": "Ikibazo cya sisitemu",
  "Network Error": "Ikibazo cya interineti",
  "Connection Error": "Ikibazo cya konekishoni",
  "Server Error": "Ikibazo cya seriveri",
  "Unknown Error": "Ikibazo kitazwi",
  "Not Found": "Ntibiboneka",
  "Access Denied": "Ntibyemewe",
  "Permission Denied": "Uburenganzira bwanze",
  "Unauthorized": "Nta burenganzira",
  "Forbidden": "Birabujijwe",
  "Timeout": "Igihe kirangiye",
  "Conflict": "Amakimbirane",
  "Bad Request": "Icyifuzo kibi",
  "Invalid Request": "Icyifuzo kitemewe",
  "Invalid Response": "Igisubizo kitemewe",
  "Invalid Credentials": "Ibimenyetso bitemewe",
  "Invalid Email": "Imeyili itemewe",
  "Invalid Password": "Ijambo ryibanga ritemewe",
  "Invalid Username": "Izina ry'ukoresha ritemewe",
  "Invalid Phone Number": "Nimero ya telefoni itemewe",
  "Invalid Date": "Itariki itemewe",
  "Invalid Time": "Igihe kitemewe",
  "Invalid Format": "Imiterere itemewe",
  "Invalid Input": "Ibyinjijwe bitemewe",
  "Required Field": "Igisabwa",
  "Field Required": "Igisabwa",
  "This field is required": "Iki gisabwa",
  "Field Too Short": "Kigufi cyane",
  "Field Too Long": "Kirekire cyane",
  "Field Too Small": "Gito cyane",
  "Field Too Large": "Kinini cyane",
  "Minimum Length": "Uburebure buto",
  "Maximum Length": "Uburebure bwinshi",
  "Minimum Value": "Agaciro gato",
  "Maximum Value": "Agaciro kinini",
  "Must match": "Bigomba guhuza",
  "Passwords do not match": "Amagambo y'ibanga ntahura",
  "Email already in use": "Imeyili isanzwe ikoreshwa",
  "Username already in use": "Izina ry'ukoresha risanzwe rikoreshwa",
  "Account already exists": "Konti isanzwe iri",
  "Account not found": "Konti ntiboneka",
  "User not found": "Ukoresha ntaboneka",
  "Wrong password": "Ijambo ryibanga ritari ryo",
  "Too many attempts": "Kugerageza kwinshi",
  "Try again later": "Gerageza nyuma",
  "Account locked": "Konti ifunze",
  "Account disabled": "Konti yahagaritswe",
  "Account expired": "Konti yarangiye",
  "Account suspended": "Konti ihagaritswe",
  "Account deleted": "Konti yasibwe",
  "Email not verified": "Imeyili ntiyemejwe",
  "Phone not verified": "Telefoni ntiyemejwe",
  "Identity not verified": "Umwirondoro ntiwemejwe",
  "Verify your email": "Emeza imeyili yawe",
  "Verify your phone": "Emeza telefoni yawe",
  "Verify your identity": "Emeza umwirondoro wawe",
  "Verification code": "Kode yo kwemeza",
  "Enter verification code": "Shyiramo kode yo kwemeza",
  "Code invalid": "Kode itari yo",
  "Code expired": "Kode yarangiye",
  "Resend code": "Ohereza kode nanone",
  "Change email": "Hindura imeyili",
  "Change phone": "Hindura telefoni",
  "Change password": "Hindura ijambo ryibanga",
  "Current password": "Ijambo ryibanga rya none",
  "New password": "Ijambo ryibanga rishya",
  "Confirm new password": "Emeza ijambo ryibanga rishya",
  "Strong password": "Ijambo ryibanga rikomeye",
  "Weak password": "Ijambo ryibanga ririmo intege",
  "Medium password": "Ijambo ryibanga riri hagati",
  "Password strength": "Imbaraga z'ijambo ryibanga",
  "Password requirements": "Ibisabwa by'ijambo ryibanga",
  "Password must contain": "Ijambo ryibanga rigomba kugira",
  "At least 8 characters": "Nibura inyuguti 8",
  "At least one uppercase letter": "Nibura inyuguti imwe nkuru",
  "At least one lowercase letter": "Nibura inyuguti imwe nto",
  "At least one number": "Nibura umubare umwe",
  "At least one special character": "Nibura ikimenyetso kidasanzwe kimwe",
  "Dashboard": "Ikibaho",
  "My Account": "Konti yanjye",
  "My Orders": "Gahunda zanjye",
  "My Wishlist": "Urutonde rwanjye",
  "My Preferences": "Ibyanjye",
  "My Downloads": "Ibyo naramoje",
  "My Uploads": "Ibyo nohereje",
  "My Tickets": "Amatike yanjye",
  "My Subscriptions": "Iyandikwa ryanjye",
  "My Points": "Amanota yanjye",
  "My Coupons": "Kuponi zanjye",
  "My Addresses": "Aderesi zanjye",
  "My Payment Methods": "Uburyo bwanjye bwo kwishyura",
  "My Notifications": "Imenyesha zanjye",
  "My Activity": "Ibikorwa byanjye",
  "Account Settings": "Igenamiterere rya konti",
  "Email Notifications": "Imenyesha za imeyili",
  "Push Notifications": "Imenyesha za telefoni",
  "SMS Notifications": "Imenyesha za SMS",
  "Web Notifications": "Imenyesha za interineti",
  "Notification Preferences": "Ibyifuzo by'imenyesha",
  "Language": "Ururimi",
  "Currency": "Ifaranga",
  "Theme": "Isura",
  "Light Mode": "Umweru",
  "Dark Mode": "Umwijima",
  "System Default": "Sisitemu",
  "Time Zone": "Isaha",
  "Calendar": "Kalendari",
  "Accessibility": "Kugerwaho",
  "Display": "Kwerekana",
  "Sound": "Ijwi",
  "Vibration": "Umutingito",
  "Alerts": "Iburira",
  "Navigation": "Kuyobora",
  "Performance": "Imikorere",
  "Safety": "Umutekano",
  "Security": "Umutekano",
  "Manage access": "Kubona imikoreshereze",
  "Two-factor authentication": "Kwemeza kabiri",
  "Recovery": "Kugarura",
  "Recovery email": "Imeyili yo kugarura",
  "Recovery phone": "Telefoni yo kugarura",
  "Recovery methods": "Uburyo bwo kugarura",
  "Backup": "Gutanga kopi",
  "Backup Now": "Gutanga kopi nonaha",
  "Last Backup": "Kopi yanyuma",
  "Restore": "Kugarura",
  "Restore Defaults": "Kugarura ibisanzwe",
  "Restore From Backup": "Kugarura kuva muri kopi",
  "Delete Account": "Gusiba konti",
  "Permanently Delete Account": "Gusiba konti burundu",
  "Delete Data": "Gusiba amakuru",
  "Delete All Data": "Gusiba amakuru yose",
  "Are you sure?": "Wemeza?",
  "This action cannot be undone": "Iki gikorwa ntikishobora gusubizwa",
  "I understand the consequences": "Nsobanukiwe n'ingaruka",
  "Type your password to confirm": "Andika ijambo ryibanga kugira ngo wemeze",
  "Save Changes": "Bika impinduka",
  "Discard Changes": "Kuraho impinduka",
  "Changes Saved": "Impinduka zabitswe",
  "Could not save changes": "Impinduka ntizabitswe",
  "Saving": "Kubika...",
  "Updating": "Kuvugurura...",
  "Updated": "Byavuguruwe",
  "Failed to update": "Kuvugurura byanze",
  "Please wait": "Nyamuneka tegereza",
  "Please wait a moment": "Nyamuneka tegereza akanya",
  "Quick Actions": "Ibikorwa byihuse",
  "More Actions": "Ibikorwa birenze",
  "Recent": "Vuba aha",
  "Recent Activity": "Ibikorwa bya vuba",
  "Recent Orders": "Gahunda za vuba",
  "Recent Transactions": "Ihererekanya rya vuba",
  "Top": "Hejuru",
  "Bottom": "Hasi",
  "Left": "Ibumoso",
  "Right": "Iburyo",
  "Center": "Hagati",
  "Middle": "Hagati",
  "Large": "Binini",
  "Medium": "Hagati",
  "Small": "Bito",
  "Start": "Gutangira",
  "End": "Kurangiza",
  "Now": "Nonaha",
  "Today": "Uyu munsi",
  "Yesterday": "Ejo hashize",
  "Tomorrow": "Ejo hazaza",
  "This Week": "Iki cyumweru",
  "Last Week": "Icyumweru gishize",
  "Next Week": "Icyumweru gitaha",
  "This Month": "Uku kwezi",
  "Last Month": "Ukwezi gushize",
  "Next Month": "Ukwezi gutaha",
  "This Year": "Uyu mwaka",
  "Last Year": "Umwaka ushize",
  "Next Year": "Umwaka utaha",
  "Custom Range": "Igice cyawe",
  "Filter": "Kuyungurura",
  "Sort": "Gutondeka",
  "Sort By": "Gutondeka na",
  "Filter By": "Kuyungurura na",
  "New": "Gishya",
  "Old": "Gishaje",
  "Newest First": "Gishya mbere",
  "Oldest First": "Gishaje mbere",
  "Price Low to High": "Igiciro kuva hasi kugeza hejuru",
  "Price High to Low": "Igiciro kuva hejuru kugeza hasi",
  "Alphabetical (A-Z)": "Mu nyuguti (A-Z)",
  "Alphabetical (Z-A)": "Mu nyuguti (Z-A)",
  "Most Popular": "Bikunzwe cyane",
  "Most Reviewed": "Byavuzweho cyane",
  "Highest Rated": "Byahawe amanota menshi",
  "Featured First": "By'ingenzi mbere",
  "Relevance": "Ibikwiye",
  "Distance": "Intera",
  "Nearest": "Hafi",
  "Farthest": "Kure",
  "Ahavexer Portal": "Ahavexer Portal",
  "Manage your Ahavex business": "Kubungabunga ubucuruzi bwawe bwa Ahavex",
  "Your Products": "Ibicuruzwa byawe",
  "Manage your product inventory": "Kubungabunga ububiko bw'ibicuruzwa byawe",
  "No products found. Start adding products to your inventory.": "Nta bicuruzwa byabonetse. Tangira wongeramo ibicuruzwa mu bubiko bwawe.",
  "Track and manage your orders": "Gukurikirana no kubungabunga gahunda zawe",
  "No orders found.": "Nta gahunda zabonetse.",
  "Manage your Ahavexer account settings": "Kubungabunga igenamiterere rya konti yawe ya Ahavexer",
  "Your account information and preferences": "Amakuru ya konti yawe n'ibyo ukunda",
  "Account Type": "Ubwoko bwa konti",
  "Ahavexer": "Ahavexer",
  "Ahavex ID": "Ahavex ID",
  "Phone Number": "Nimero ya telefoni",
  "Last Updated": "Byavuguruwe bwa nyuma",
  "Profile Image": "Ishusho y'umwirondoro",
  "Update Profile Picture": "Kuvugurura ishusho y'umwirondoro",
  "Image size should be less than 3MB": "Ingano y'ishusho igomba kuba munsi ya 3MB",
  "Detailed Account Information": "Amakuru arambuye ya konti",
  "Last Login": "Kwinjira bwa nyuma",
  "Created At": "Itariki yo kurema",
  "Revenue": "Amafaranga yinjije",
  "Customers": "Abakiliya",
  "Processing...": "Gutunganya...",
  "Images will be compressed to 10% of original size": "Amashusho azagabanywa kugeza kuri 10% by'ingano y'umwimerere"
};
